import { useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import {
  GOLD, GUEST, SILVER, TWEETS,
} from '../../../../data/permissions';

import SwitchButton from '../../../MainTrending/TrendingFilters/TrendingPersonalisationFilter/SwitchButton';
import UpgradeTooltipSmall from '../../../GeneralComponents/UpgradeTooltip/UpgradeTooltipSmall';
import Tooltip from '../../../Tooltip';

import Styles from '../../story-filters-styles.module.scss';

import withComponentName from '../../../../decorators/withComponentName';

const cx = classNames.bind(Styles);

export const DropdownItem = ({
  index, item, width,
  premiumContentFilter,
  setValueSelected,
  majorContentFilter,
  onboarding,
  lastChild,
}) => {
  const {
    disabled,
    accessLevels,
    goldUser,
    isPremiumLabelsEnabled,
    showTweets,
    silverUser,
  } = useSelector(({ subscriptions, storyFilters }) => {
    const { permissions, permissionsInitialized } = subscriptions;
    const { access_levels: accessLevels } = permissions;
    const { isPremiumLabelsEnabled } = storyFilters;

    const disabled = Boolean(
      (item.premiumOnly && !permissionsInitialized) || premiumContentFilter,
    );

    return {
      disabled,
      accessLevels,
      isPremiumLabelsEnabled,
      goldUser: accessLevels.includes(GOLD),
      guest: accessLevels[0] === GUEST,
      silverUser: accessLevels.includes(SILVER),
    };
  });

  const onSelect = (subItem) => {
    setValueSelected(item, subItem);
  };

  const onSelectHandler = () => {
    if (!premiumContentFilter) {
      onSelect(null);
    } else {
      setValueSelected(item);
    }
  };
  const staticUpgTooltClass = onboarding ? 'pref-upgrade-silver-tooltip--onboarding' : 'pref-upgrade-silver-tooltip';

  return (
    <div
      className={
        cx(
          'dropdown-item-wrapper',
          {
            disabled: disabled && premiumContentFilter,
            'premium-content-wrapper': premiumContentFilter || majorContentFilter,
            'gold-content-wrapper': premiumContentFilter,
            news: item.name === 'News Publications',
            last: lastChild,
            'cant-use-tweets': !accessLevels.includes(TWEETS),
            onboarding,
          },
        )
      }
    >
      <Dropdown.Item
        eventKey={index}
        active={item.select}
        onSelect={onSelectHandler}
        bsPrefix={cx('parent_checkbox', { active: item.select }, { 'gold-user': goldUser })}
      >
        {!premiumContentFilter && !majorContentFilter && (
          <span className={cx('checkbox_box')}>
            {item.select && <FontAwesomeIcon icon={faCheck} />}
          </span>
        )}
        <span
          className={cx(
            'dropdown__checkbox_title',
            { 'toggle-checkbox-title': premiumContentFilter || majorContentFilter },
          )}
        >
          <span>
            {onboarding ? ((item.name === 'Premium Content ONLY' && 'Show Premium Content ONLY') || item.name) : item.name}
          </span>
        </span>
        {(premiumContentFilter || majorContentFilter) && (
          <SwitchButton
            disabled={disabled && premiumContentFilter && !goldUser}
            id={`switch__${item.name}`}
            status={item.select}
            item={item}
            className={`${cx('sourcesFilter')} pref-sources-filter`}
            onboarding={onboarding}
            onlyGold={premiumContentFilter}
            goldUser={goldUser && premiumContentFilter}
          />
        )}
      </Dropdown.Item>
      {premiumContentFilter && (
        <Tooltip className={`${cx('premium__content--tooltip')} premium__content--tooltip`}>
          This is content with full text without
          <br />
          {' '}
          any advertising, paywall or clutter.
          <br />
          {' '}
          <a href="https://www.cityfalcon.ai/help/articles/360034657073" target="_blank" rel="noopener noreferrer">
            Learn More
          </a>
        </Tooltip>
      )}
      {majorContentFilter && (
        <Tooltip className={cx('major__content--tooltip')}>
          These are select reputed sources
          <br />
          {' '}
          our curators have selected.
          <br />
          {' '}
        </Tooltip>
      )}
      {disabled && (
        <div className={`${cx('upgrade-tooltip',
          { 'category-gold': premiumContentFilter },
          { 'gold-user': goldUser })} pref-ugrade-gold-tooltip`}
        >
          {premiumContentFilter && isPremiumLabelsEnabled && (
            <UpgradeTooltipSmall
              width={width}
              planBadgeText="Gold"
              isGold={goldUser}
              isSilver={silverUser}
              premiumContentFilter
              cssClass="source-gold-tooltip"
            />
          )}
        </div>
      )}
      {(!premiumContentFilter && !majorContentFilter) && onboarding && (
        <>
          {item.name === 'News Publications' && (
            <Tooltip className="onboarding-sources--tooltip news">
              Well over 10.000 sources vetted by our analysts for quality standards.
            </Tooltip>
          )}
          {item.name === 'Tweets' && (
            <Tooltip className="onboarding-sources--tooltip tweets">
              Curated financial Twitter without the spam and junk.
            </Tooltip>
          )}
          {item.name === 'Research' && (
            <Tooltip className="onboarding-sources--tooltip research">
              Post MiFID-II research available to the public from major research houses.
            </Tooltip>
          )}
        </>
      )}
      {item.name === 'Tweets' && (
        <div className={`${cx('upgrade-tooltip', 'tweets',
          { 'category-gold': premiumContentFilter },
          { 'gold-user': showTweets })} ${staticUpgTooltClass}`}
        >
          {isPremiumLabelsEnabled && (
            <UpgradeTooltipSmall
              width={width}
              planBadgeText="Silver"
              cssClass="source-gold-tooltip"
              isGold={goldUser}
              isSilver={silverUser}
            />
          )}
        </div>
      )}
      <div className={cx('dropdown-item-wrapper__subitems')}>
        {!onboarding && item.sub?.map((subItem) => (
          <span
            key={subItem.name}
            className={cx('child_checkbox', { active: subItem.select })}
            onClick={() => onSelect(subItem)}
          >
            <span className={cx('checkbox_box')}>
              {subItem.select && <FontAwesomeIcon icon={faCheck} />}
            </span>
            <span className={cx('dropdown__checkbox_title')}>{subItem.name}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default withComponentName(DropdownItem);
